// extracted by mini-css-extract-plugin
export default {"container":"TitledPage_container__n2W7a","title":"TitledPage_title__6LXCf","page":"TitledPage_page__5iDEF"};